import { gql } from '@apollo/client';

export const UpdateInvoice = gql`
mutation UpdateInvoice($content: contentInvoice!, $updateInvoiceId: ID!) {
  updateInvoice(content: $content, id: $updateInvoiceId) {
    status
  }
}
`;
